/**
 * Generated by orval 🍺
 * Do not edit manually.
 * Internal API
 * OpenAPI spec version: v1
 */
import {
  queryOptions as queryOptionsBuilder,
  useQuery,
  useSuspenseQuery
} from '@tanstack/react-query';
import type {
  DataTag,
  DefinedInitialDataOptions,
  DefinedUseQueryResult,
  QueryClient,
  QueryFunction,
  QueryKey,
  UndefinedInitialDataOptions,
  UseQueryOptions,
  UseQueryResult,
  UseSuspenseQueryOptions,
  UseSuspenseQueryResult
} from '@tanstack/react-query';

import type {
  GetRequestableAbsenceShiftTypesForDepartmentParams,
  GetRequestablePresenceShiftTypesForDepartmentParams,
  GetShiftTemplatesByPersonParams,
  GetShiftTypeParams,
  GetShiftTypesByPersonParams,
  ShiftTypeDto
} from '../../model';

import { customInstance } from '../../../mutator.ts';
import type { ErrorType } from '../../../mutator.ts';


type SecondParameter<T extends (...args: never) => unknown> = Parameters<T>[1];



const withQueryKey = <T extends object, K>(query: T, queryKey: K): T & { queryKey: K } => {
  const result = { queryKey } as T & { queryKey: K };
  for (const key of Object.keys(query)) {
    // The explicit queryKey always wins, matching the previous
    // `{ ...query, queryKey }` spread where it was set last.
    if (key === 'queryKey') continue;
    Object.defineProperty(result, key, {
      enumerable: true,
      configurable: true,
      get: () => (query as Record<string, unknown>)[key],
    });
  }
  return result;
};

export const getShiftTypeGetShiftTypesUrl = () => {




  return `/api/ShiftType/GetShiftTypes`
}

export const shiftTypeGetShiftTypes = async ( options?: Parameters<typeof customInstance>[1]): Promise<ShiftTypeDto[]> => {

  return customInstance<ShiftTypeDto[]>(getShiftTypeGetShiftTypesUrl(),
  {
    ...options,
    method: 'GET'


  }
);}





export const getShiftTypeGetShiftTypesQueryKey = () => {
    return [
    `/api/ShiftType/GetShiftTypes`
    ] as const;
    }


export const getShiftTypeGetShiftTypesQueryOptions = <TData = Awaited<ReturnType<typeof shiftTypeGetShiftTypes>>, TError = ErrorType<unknown>>( options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof shiftTypeGetShiftTypes>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getShiftTypeGetShiftTypesQueryKey();



    const queryFn: QueryFunction<Awaited<ReturnType<typeof shiftTypeGetShiftTypes>>> = ({ signal }) => shiftTypeGetShiftTypes({ signal, ...requestOptions });





   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof shiftTypeGetShiftTypes>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type ShiftTypeGetShiftTypesQueryResult = NonNullable<Awaited<ReturnType<typeof shiftTypeGetShiftTypes>>>
export type ShiftTypeGetShiftTypesQueryError = ErrorType<unknown>


export function useShiftTypeGetShiftTypes<TData = Awaited<ReturnType<typeof shiftTypeGetShiftTypes>>, TError = ErrorType<unknown>>(
  options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof shiftTypeGetShiftTypes>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof shiftTypeGetShiftTypes>>,
          TError,
          Awaited<ReturnType<typeof shiftTypeGetShiftTypes>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useShiftTypeGetShiftTypes<TData = Awaited<ReturnType<typeof shiftTypeGetShiftTypes>>, TError = ErrorType<unknown>>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof shiftTypeGetShiftTypes>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof shiftTypeGetShiftTypes>>,
          TError,
          Awaited<ReturnType<typeof shiftTypeGetShiftTypes>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useShiftTypeGetShiftTypes<TData = Awaited<ReturnType<typeof shiftTypeGetShiftTypes>>, TError = ErrorType<unknown>>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof shiftTypeGetShiftTypes>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }

export function useShiftTypeGetShiftTypes<TData = Awaited<ReturnType<typeof shiftTypeGetShiftTypes>>, TError = ErrorType<unknown>>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof shiftTypeGetShiftTypes>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getShiftTypeGetShiftTypesQueryOptions(options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}






export const getShiftTypeGetShiftTypesSuspenseQueryOptions = <TData = Awaited<ReturnType<typeof shiftTypeGetShiftTypes>>, TError = ErrorType<unknown>>( options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof shiftTypeGetShiftTypes>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getShiftTypeGetShiftTypesQueryKey();



    const queryFn: QueryFunction<Awaited<ReturnType<typeof shiftTypeGetShiftTypes>>> = ({ signal }) => shiftTypeGetShiftTypes({ signal, ...requestOptions });





   return  queryOptionsBuilder({ queryKey, ...queryOptions, queryFn: queryOptions?.queryFn ?? queryFn}) as UseSuspenseQueryOptions<Awaited<ReturnType<typeof shiftTypeGetShiftTypes>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> } & { throwOnError?: ((this: never, error: TError) => boolean) & { readonly __inferenceOnly: never } }
}

export type ShiftTypeGetShiftTypesSuspenseQueryResult = NonNullable<Awaited<ReturnType<typeof shiftTypeGetShiftTypes>>>
export type ShiftTypeGetShiftTypesSuspenseQueryError = ErrorType<unknown>


export function useShiftTypeGetShiftTypesSuspense<TData = Awaited<ReturnType<typeof shiftTypeGetShiftTypes>>, TError = ErrorType<unknown>>(
  options: { query:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof shiftTypeGetShiftTypes>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useShiftTypeGetShiftTypesSuspense<TData = Awaited<ReturnType<typeof shiftTypeGetShiftTypes>>, TError = ErrorType<unknown>>(
  options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof shiftTypeGetShiftTypes>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useShiftTypeGetShiftTypesSuspense<TData = Awaited<ReturnType<typeof shiftTypeGetShiftTypes>>, TError = ErrorType<unknown>>(
  options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof shiftTypeGetShiftTypes>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }

export function useShiftTypeGetShiftTypesSuspense<TData = Awaited<ReturnType<typeof shiftTypeGetShiftTypes>>, TError = ErrorType<unknown>>(
  options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof shiftTypeGetShiftTypes>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
 ):  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getShiftTypeGetShiftTypesSuspenseQueryOptions(options)

  const query = useSuspenseQuery(queryOptions, queryClient) as  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}






export const getGetShiftTypeUrl = (params?: GetShiftTypeParams,) => {
  const normalizedParams = new URLSearchParams();

  Object.entries(params || {}).forEach(([key, value]) => {

    if (value !== undefined) {
      normalizedParams.append(key, value === null ? 'null' : String(value))
    }
  });

  const stringifiedParams = normalizedParams.toString();

  return stringifiedParams.length > 0 ? `/api/ShiftType/GetShiftType?${stringifiedParams}` : `/api/ShiftType/GetShiftType`
}

export const getShiftType = async (params?: GetShiftTypeParams, options?: Parameters<typeof customInstance>[1]): Promise<ShiftTypeDto> => {

  return customInstance<ShiftTypeDto>(getGetShiftTypeUrl(params),
  {
    ...options,
    method: 'GET'


  }
);}





export const getGetShiftTypeQueryKey = (params?: GetShiftTypeParams,) => {
    return [
    `/api/ShiftType/GetShiftType`, ...(params ? [params] : [])
    ] as const;
    }


export const getGetShiftTypeQueryOptions = <TData = Awaited<ReturnType<typeof getShiftType>>, TError = ErrorType<unknown>>(params?: GetShiftTypeParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getShiftType>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetShiftTypeQueryKey(params);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof getShiftType>>> = ({ signal }) => getShiftType(params, { signal, ...requestOptions });





   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getShiftType>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type GetShiftTypeQueryResult = NonNullable<Awaited<ReturnType<typeof getShiftType>>>
export type GetShiftTypeQueryError = ErrorType<unknown>


export function useGetShiftType<TData = Awaited<ReturnType<typeof getShiftType>>, TError = ErrorType<unknown>>(
 params: undefined |  GetShiftTypeParams, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof getShiftType>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getShiftType>>,
          TError,
          Awaited<ReturnType<typeof getShiftType>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetShiftType<TData = Awaited<ReturnType<typeof getShiftType>>, TError = ErrorType<unknown>>(
 params?: GetShiftTypeParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getShiftType>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getShiftType>>,
          TError,
          Awaited<ReturnType<typeof getShiftType>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetShiftType<TData = Awaited<ReturnType<typeof getShiftType>>, TError = ErrorType<unknown>>(
 params?: GetShiftTypeParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getShiftType>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }

export function useGetShiftType<TData = Awaited<ReturnType<typeof getShiftType>>, TError = ErrorType<unknown>>(
 params?: GetShiftTypeParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getShiftType>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getGetShiftTypeQueryOptions(params,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}






export const getGetShiftTypeSuspenseQueryOptions = <TData = Awaited<ReturnType<typeof getShiftType>>, TError = ErrorType<unknown>>(params?: GetShiftTypeParams, options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof getShiftType>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetShiftTypeQueryKey(params);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof getShiftType>>> = ({ signal }) => getShiftType(params, { signal, ...requestOptions });





   return  queryOptionsBuilder({ queryKey, ...queryOptions, queryFn: queryOptions?.queryFn ?? queryFn}) as UseSuspenseQueryOptions<Awaited<ReturnType<typeof getShiftType>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> } & { throwOnError?: ((this: never, error: TError) => boolean) & { readonly __inferenceOnly: never } }
}

export type GetShiftTypeSuspenseQueryResult = NonNullable<Awaited<ReturnType<typeof getShiftType>>>
export type GetShiftTypeSuspenseQueryError = ErrorType<unknown>


export function useGetShiftTypeSuspense<TData = Awaited<ReturnType<typeof getShiftType>>, TError = ErrorType<unknown>>(
 params: undefined |  GetShiftTypeParams, options: { query:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof getShiftType>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetShiftTypeSuspense<TData = Awaited<ReturnType<typeof getShiftType>>, TError = ErrorType<unknown>>(
 params?: GetShiftTypeParams, options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof getShiftType>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetShiftTypeSuspense<TData = Awaited<ReturnType<typeof getShiftType>>, TError = ErrorType<unknown>>(
 params?: GetShiftTypeParams, options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof getShiftType>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }

export function useGetShiftTypeSuspense<TData = Awaited<ReturnType<typeof getShiftType>>, TError = ErrorType<unknown>>(
 params?: GetShiftTypeParams, options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof getShiftType>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
 ):  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getGetShiftTypeSuspenseQueryOptions(params,options)

  const query = useSuspenseQuery(queryOptions, queryClient) as  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}






export const getGetShiftTypesByPersonUrl = (params?: GetShiftTypesByPersonParams,) => {
  const normalizedParams = new URLSearchParams();

  Object.entries(params || {}).forEach(([key, value]) => {

    if (value !== undefined) {
      normalizedParams.append(key, value === null ? 'null' : String(value))
    }
  });

  const stringifiedParams = normalizedParams.toString();

  return stringifiedParams.length > 0 ? `/api/ShiftType/GetShiftTypesByPerson?${stringifiedParams}` : `/api/ShiftType/GetShiftTypesByPerson`
}

export const getShiftTypesByPerson = async (params?: GetShiftTypesByPersonParams, options?: Parameters<typeof customInstance>[1]): Promise<ShiftTypeDto[]> => {

  return customInstance<ShiftTypeDto[]>(getGetShiftTypesByPersonUrl(params),
  {
    ...options,
    method: 'GET'


  }
);}





export const getGetShiftTypesByPersonQueryKey = (params?: GetShiftTypesByPersonParams,) => {
    return [
    `/api/ShiftType/GetShiftTypesByPerson`, ...(params ? [params] : [])
    ] as const;
    }


export const getGetShiftTypesByPersonQueryOptions = <TData = Awaited<ReturnType<typeof getShiftTypesByPerson>>, TError = ErrorType<unknown>>(params?: GetShiftTypesByPersonParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getShiftTypesByPerson>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetShiftTypesByPersonQueryKey(params);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof getShiftTypesByPerson>>> = ({ signal }) => getShiftTypesByPerson(params, { signal, ...requestOptions });





   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getShiftTypesByPerson>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type GetShiftTypesByPersonQueryResult = NonNullable<Awaited<ReturnType<typeof getShiftTypesByPerson>>>
export type GetShiftTypesByPersonQueryError = ErrorType<unknown>


export function useGetShiftTypesByPerson<TData = Awaited<ReturnType<typeof getShiftTypesByPerson>>, TError = ErrorType<unknown>>(
 params: undefined |  GetShiftTypesByPersonParams, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof getShiftTypesByPerson>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getShiftTypesByPerson>>,
          TError,
          Awaited<ReturnType<typeof getShiftTypesByPerson>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetShiftTypesByPerson<TData = Awaited<ReturnType<typeof getShiftTypesByPerson>>, TError = ErrorType<unknown>>(
 params?: GetShiftTypesByPersonParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getShiftTypesByPerson>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getShiftTypesByPerson>>,
          TError,
          Awaited<ReturnType<typeof getShiftTypesByPerson>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetShiftTypesByPerson<TData = Awaited<ReturnType<typeof getShiftTypesByPerson>>, TError = ErrorType<unknown>>(
 params?: GetShiftTypesByPersonParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getShiftTypesByPerson>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }

export function useGetShiftTypesByPerson<TData = Awaited<ReturnType<typeof getShiftTypesByPerson>>, TError = ErrorType<unknown>>(
 params?: GetShiftTypesByPersonParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getShiftTypesByPerson>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getGetShiftTypesByPersonQueryOptions(params,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}






export const getGetShiftTypesByPersonSuspenseQueryOptions = <TData = Awaited<ReturnType<typeof getShiftTypesByPerson>>, TError = ErrorType<unknown>>(params?: GetShiftTypesByPersonParams, options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof getShiftTypesByPerson>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetShiftTypesByPersonQueryKey(params);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof getShiftTypesByPerson>>> = ({ signal }) => getShiftTypesByPerson(params, { signal, ...requestOptions });





   return  queryOptionsBuilder({ queryKey, ...queryOptions, queryFn: queryOptions?.queryFn ?? queryFn}) as UseSuspenseQueryOptions<Awaited<ReturnType<typeof getShiftTypesByPerson>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> } & { throwOnError?: ((this: never, error: TError) => boolean) & { readonly __inferenceOnly: never } }
}

export type GetShiftTypesByPersonSuspenseQueryResult = NonNullable<Awaited<ReturnType<typeof getShiftTypesByPerson>>>
export type GetShiftTypesByPersonSuspenseQueryError = ErrorType<unknown>


export function useGetShiftTypesByPersonSuspense<TData = Awaited<ReturnType<typeof getShiftTypesByPerson>>, TError = ErrorType<unknown>>(
 params: undefined |  GetShiftTypesByPersonParams, options: { query:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof getShiftTypesByPerson>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetShiftTypesByPersonSuspense<TData = Awaited<ReturnType<typeof getShiftTypesByPerson>>, TError = ErrorType<unknown>>(
 params?: GetShiftTypesByPersonParams, options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof getShiftTypesByPerson>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetShiftTypesByPersonSuspense<TData = Awaited<ReturnType<typeof getShiftTypesByPerson>>, TError = ErrorType<unknown>>(
 params?: GetShiftTypesByPersonParams, options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof getShiftTypesByPerson>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }

export function useGetShiftTypesByPersonSuspense<TData = Awaited<ReturnType<typeof getShiftTypesByPerson>>, TError = ErrorType<unknown>>(
 params?: GetShiftTypesByPersonParams, options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof getShiftTypesByPerson>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
 ):  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getGetShiftTypesByPersonSuspenseQueryOptions(params,options)

  const query = useSuspenseQuery(queryOptions, queryClient) as  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}






export const getGetShiftTemplatesByPersonUrl = (params?: GetShiftTemplatesByPersonParams,) => {
  const normalizedParams = new URLSearchParams();

  Object.entries(params || {}).forEach(([key, value]) => {

    if (value !== undefined) {
      normalizedParams.append(key, value === null ? 'null' : String(value))
    }
  });

  const stringifiedParams = normalizedParams.toString();

  return stringifiedParams.length > 0 ? `/api/ShiftType/GetShiftTemplatesByPerson?${stringifiedParams}` : `/api/ShiftType/GetShiftTemplatesByPerson`
}

export const getShiftTemplatesByPerson = async (params?: GetShiftTemplatesByPersonParams, options?: Parameters<typeof customInstance>[1]): Promise<ShiftTypeDto[]> => {

  return customInstance<ShiftTypeDto[]>(getGetShiftTemplatesByPersonUrl(params),
  {
    ...options,
    method: 'GET'


  }
);}





export const getGetShiftTemplatesByPersonQueryKey = (params?: GetShiftTemplatesByPersonParams,) => {
    return [
    `/api/ShiftType/GetShiftTemplatesByPerson`, ...(params ? [params] : [])
    ] as const;
    }


export const getGetShiftTemplatesByPersonQueryOptions = <TData = Awaited<ReturnType<typeof getShiftTemplatesByPerson>>, TError = ErrorType<unknown>>(params?: GetShiftTemplatesByPersonParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getShiftTemplatesByPerson>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetShiftTemplatesByPersonQueryKey(params);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof getShiftTemplatesByPerson>>> = ({ signal }) => getShiftTemplatesByPerson(params, { signal, ...requestOptions });





   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getShiftTemplatesByPerson>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type GetShiftTemplatesByPersonQueryResult = NonNullable<Awaited<ReturnType<typeof getShiftTemplatesByPerson>>>
export type GetShiftTemplatesByPersonQueryError = ErrorType<unknown>


export function useGetShiftTemplatesByPerson<TData = Awaited<ReturnType<typeof getShiftTemplatesByPerson>>, TError = ErrorType<unknown>>(
 params: undefined |  GetShiftTemplatesByPersonParams, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof getShiftTemplatesByPerson>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getShiftTemplatesByPerson>>,
          TError,
          Awaited<ReturnType<typeof getShiftTemplatesByPerson>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetShiftTemplatesByPerson<TData = Awaited<ReturnType<typeof getShiftTemplatesByPerson>>, TError = ErrorType<unknown>>(
 params?: GetShiftTemplatesByPersonParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getShiftTemplatesByPerson>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getShiftTemplatesByPerson>>,
          TError,
          Awaited<ReturnType<typeof getShiftTemplatesByPerson>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetShiftTemplatesByPerson<TData = Awaited<ReturnType<typeof getShiftTemplatesByPerson>>, TError = ErrorType<unknown>>(
 params?: GetShiftTemplatesByPersonParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getShiftTemplatesByPerson>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }

export function useGetShiftTemplatesByPerson<TData = Awaited<ReturnType<typeof getShiftTemplatesByPerson>>, TError = ErrorType<unknown>>(
 params?: GetShiftTemplatesByPersonParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getShiftTemplatesByPerson>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getGetShiftTemplatesByPersonQueryOptions(params,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}






export const getGetShiftTemplatesByPersonSuspenseQueryOptions = <TData = Awaited<ReturnType<typeof getShiftTemplatesByPerson>>, TError = ErrorType<unknown>>(params?: GetShiftTemplatesByPersonParams, options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof getShiftTemplatesByPerson>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetShiftTemplatesByPersonQueryKey(params);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof getShiftTemplatesByPerson>>> = ({ signal }) => getShiftTemplatesByPerson(params, { signal, ...requestOptions });





   return  queryOptionsBuilder({ queryKey, ...queryOptions, queryFn: queryOptions?.queryFn ?? queryFn}) as UseSuspenseQueryOptions<Awaited<ReturnType<typeof getShiftTemplatesByPerson>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> } & { throwOnError?: ((this: never, error: TError) => boolean) & { readonly __inferenceOnly: never } }
}

export type GetShiftTemplatesByPersonSuspenseQueryResult = NonNullable<Awaited<ReturnType<typeof getShiftTemplatesByPerson>>>
export type GetShiftTemplatesByPersonSuspenseQueryError = ErrorType<unknown>


export function useGetShiftTemplatesByPersonSuspense<TData = Awaited<ReturnType<typeof getShiftTemplatesByPerson>>, TError = ErrorType<unknown>>(
 params: undefined |  GetShiftTemplatesByPersonParams, options: { query:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof getShiftTemplatesByPerson>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetShiftTemplatesByPersonSuspense<TData = Awaited<ReturnType<typeof getShiftTemplatesByPerson>>, TError = ErrorType<unknown>>(
 params?: GetShiftTemplatesByPersonParams, options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof getShiftTemplatesByPerson>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetShiftTemplatesByPersonSuspense<TData = Awaited<ReturnType<typeof getShiftTemplatesByPerson>>, TError = ErrorType<unknown>>(
 params?: GetShiftTemplatesByPersonParams, options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof getShiftTemplatesByPerson>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }

export function useGetShiftTemplatesByPersonSuspense<TData = Awaited<ReturnType<typeof getShiftTemplatesByPerson>>, TError = ErrorType<unknown>>(
 params?: GetShiftTemplatesByPersonParams, options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof getShiftTemplatesByPerson>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
 ):  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getGetShiftTemplatesByPersonSuspenseQueryOptions(params,options)

  const query = useSuspenseQuery(queryOptions, queryClient) as  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}






export const getGetRequestablePresenceShiftTypesForDepartmentUrl = (params?: GetRequestablePresenceShiftTypesForDepartmentParams,) => {
  const normalizedParams = new URLSearchParams();

  Object.entries(params || {}).forEach(([key, value]) => {

    if (value !== undefined) {
      normalizedParams.append(key, value === null ? 'null' : String(value))
    }
  });

  const stringifiedParams = normalizedParams.toString();

  return stringifiedParams.length > 0 ? `/api/ShiftType/GetRequestablePresenceShiftTypesForDepartment?${stringifiedParams}` : `/api/ShiftType/GetRequestablePresenceShiftTypesForDepartment`
}

export const getRequestablePresenceShiftTypesForDepartment = async (params?: GetRequestablePresenceShiftTypesForDepartmentParams, options?: Parameters<typeof customInstance>[1]): Promise<ShiftTypeDto[]> => {

  return customInstance<ShiftTypeDto[]>(getGetRequestablePresenceShiftTypesForDepartmentUrl(params),
  {
    ...options,
    method: 'GET'


  }
);}





export const getGetRequestablePresenceShiftTypesForDepartmentQueryKey = (params?: GetRequestablePresenceShiftTypesForDepartmentParams,) => {
    return [
    `/api/ShiftType/GetRequestablePresenceShiftTypesForDepartment`, ...(params ? [params] : [])
    ] as const;
    }


export const getGetRequestablePresenceShiftTypesForDepartmentQueryOptions = <TData = Awaited<ReturnType<typeof getRequestablePresenceShiftTypesForDepartment>>, TError = ErrorType<unknown>>(params?: GetRequestablePresenceShiftTypesForDepartmentParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getRequestablePresenceShiftTypesForDepartment>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetRequestablePresenceShiftTypesForDepartmentQueryKey(params);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof getRequestablePresenceShiftTypesForDepartment>>> = ({ signal }) => getRequestablePresenceShiftTypesForDepartment(params, { signal, ...requestOptions });





   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getRequestablePresenceShiftTypesForDepartment>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type GetRequestablePresenceShiftTypesForDepartmentQueryResult = NonNullable<Awaited<ReturnType<typeof getRequestablePresenceShiftTypesForDepartment>>>
export type GetRequestablePresenceShiftTypesForDepartmentQueryError = ErrorType<unknown>


export function useGetRequestablePresenceShiftTypesForDepartment<TData = Awaited<ReturnType<typeof getRequestablePresenceShiftTypesForDepartment>>, TError = ErrorType<unknown>>(
 params: undefined |  GetRequestablePresenceShiftTypesForDepartmentParams, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof getRequestablePresenceShiftTypesForDepartment>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getRequestablePresenceShiftTypesForDepartment>>,
          TError,
          Awaited<ReturnType<typeof getRequestablePresenceShiftTypesForDepartment>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetRequestablePresenceShiftTypesForDepartment<TData = Awaited<ReturnType<typeof getRequestablePresenceShiftTypesForDepartment>>, TError = ErrorType<unknown>>(
 params?: GetRequestablePresenceShiftTypesForDepartmentParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getRequestablePresenceShiftTypesForDepartment>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getRequestablePresenceShiftTypesForDepartment>>,
          TError,
          Awaited<ReturnType<typeof getRequestablePresenceShiftTypesForDepartment>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetRequestablePresenceShiftTypesForDepartment<TData = Awaited<ReturnType<typeof getRequestablePresenceShiftTypesForDepartment>>, TError = ErrorType<unknown>>(
 params?: GetRequestablePresenceShiftTypesForDepartmentParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getRequestablePresenceShiftTypesForDepartment>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }

export function useGetRequestablePresenceShiftTypesForDepartment<TData = Awaited<ReturnType<typeof getRequestablePresenceShiftTypesForDepartment>>, TError = ErrorType<unknown>>(
 params?: GetRequestablePresenceShiftTypesForDepartmentParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getRequestablePresenceShiftTypesForDepartment>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getGetRequestablePresenceShiftTypesForDepartmentQueryOptions(params,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}






export const getGetRequestablePresenceShiftTypesForDepartmentSuspenseQueryOptions = <TData = Awaited<ReturnType<typeof getRequestablePresenceShiftTypesForDepartment>>, TError = ErrorType<unknown>>(params?: GetRequestablePresenceShiftTypesForDepartmentParams, options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof getRequestablePresenceShiftTypesForDepartment>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetRequestablePresenceShiftTypesForDepartmentQueryKey(params);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof getRequestablePresenceShiftTypesForDepartment>>> = ({ signal }) => getRequestablePresenceShiftTypesForDepartment(params, { signal, ...requestOptions });





   return  queryOptionsBuilder({ queryKey, ...queryOptions, queryFn: queryOptions?.queryFn ?? queryFn}) as UseSuspenseQueryOptions<Awaited<ReturnType<typeof getRequestablePresenceShiftTypesForDepartment>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> } & { throwOnError?: ((this: never, error: TError) => boolean) & { readonly __inferenceOnly: never } }
}

export type GetRequestablePresenceShiftTypesForDepartmentSuspenseQueryResult = NonNullable<Awaited<ReturnType<typeof getRequestablePresenceShiftTypesForDepartment>>>
export type GetRequestablePresenceShiftTypesForDepartmentSuspenseQueryError = ErrorType<unknown>


export function useGetRequestablePresenceShiftTypesForDepartmentSuspense<TData = Awaited<ReturnType<typeof getRequestablePresenceShiftTypesForDepartment>>, TError = ErrorType<unknown>>(
 params: undefined |  GetRequestablePresenceShiftTypesForDepartmentParams, options: { query:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof getRequestablePresenceShiftTypesForDepartment>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetRequestablePresenceShiftTypesForDepartmentSuspense<TData = Awaited<ReturnType<typeof getRequestablePresenceShiftTypesForDepartment>>, TError = ErrorType<unknown>>(
 params?: GetRequestablePresenceShiftTypesForDepartmentParams, options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof getRequestablePresenceShiftTypesForDepartment>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetRequestablePresenceShiftTypesForDepartmentSuspense<TData = Awaited<ReturnType<typeof getRequestablePresenceShiftTypesForDepartment>>, TError = ErrorType<unknown>>(
 params?: GetRequestablePresenceShiftTypesForDepartmentParams, options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof getRequestablePresenceShiftTypesForDepartment>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }

export function useGetRequestablePresenceShiftTypesForDepartmentSuspense<TData = Awaited<ReturnType<typeof getRequestablePresenceShiftTypesForDepartment>>, TError = ErrorType<unknown>>(
 params?: GetRequestablePresenceShiftTypesForDepartmentParams, options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof getRequestablePresenceShiftTypesForDepartment>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
 ):  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getGetRequestablePresenceShiftTypesForDepartmentSuspenseQueryOptions(params,options)

  const query = useSuspenseQuery(queryOptions, queryClient) as  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}






export const getGetRequestableAbsenceShiftTypesForDepartmentUrl = (params?: GetRequestableAbsenceShiftTypesForDepartmentParams,) => {
  const normalizedParams = new URLSearchParams();

  Object.entries(params || {}).forEach(([key, value]) => {

    if (value !== undefined) {
      normalizedParams.append(key, value === null ? 'null' : String(value))
    }
  });

  const stringifiedParams = normalizedParams.toString();

  return stringifiedParams.length > 0 ? `/api/ShiftType/GetRequestableAbsenceShiftTypesForDepartment?${stringifiedParams}` : `/api/ShiftType/GetRequestableAbsenceShiftTypesForDepartment`
}

export const getRequestableAbsenceShiftTypesForDepartment = async (params?: GetRequestableAbsenceShiftTypesForDepartmentParams, options?: Parameters<typeof customInstance>[1]): Promise<ShiftTypeDto[]> => {

  return customInstance<ShiftTypeDto[]>(getGetRequestableAbsenceShiftTypesForDepartmentUrl(params),
  {
    ...options,
    method: 'GET'


  }
);}





export const getGetRequestableAbsenceShiftTypesForDepartmentQueryKey = (params?: GetRequestableAbsenceShiftTypesForDepartmentParams,) => {
    return [
    `/api/ShiftType/GetRequestableAbsenceShiftTypesForDepartment`, ...(params ? [params] : [])
    ] as const;
    }


export const getGetRequestableAbsenceShiftTypesForDepartmentQueryOptions = <TData = Awaited<ReturnType<typeof getRequestableAbsenceShiftTypesForDepartment>>, TError = ErrorType<unknown>>(params?: GetRequestableAbsenceShiftTypesForDepartmentParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getRequestableAbsenceShiftTypesForDepartment>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetRequestableAbsenceShiftTypesForDepartmentQueryKey(params);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof getRequestableAbsenceShiftTypesForDepartment>>> = ({ signal }) => getRequestableAbsenceShiftTypesForDepartment(params, { signal, ...requestOptions });





   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getRequestableAbsenceShiftTypesForDepartment>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type GetRequestableAbsenceShiftTypesForDepartmentQueryResult = NonNullable<Awaited<ReturnType<typeof getRequestableAbsenceShiftTypesForDepartment>>>
export type GetRequestableAbsenceShiftTypesForDepartmentQueryError = ErrorType<unknown>


export function useGetRequestableAbsenceShiftTypesForDepartment<TData = Awaited<ReturnType<typeof getRequestableAbsenceShiftTypesForDepartment>>, TError = ErrorType<unknown>>(
 params: undefined |  GetRequestableAbsenceShiftTypesForDepartmentParams, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof getRequestableAbsenceShiftTypesForDepartment>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getRequestableAbsenceShiftTypesForDepartment>>,
          TError,
          Awaited<ReturnType<typeof getRequestableAbsenceShiftTypesForDepartment>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetRequestableAbsenceShiftTypesForDepartment<TData = Awaited<ReturnType<typeof getRequestableAbsenceShiftTypesForDepartment>>, TError = ErrorType<unknown>>(
 params?: GetRequestableAbsenceShiftTypesForDepartmentParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getRequestableAbsenceShiftTypesForDepartment>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getRequestableAbsenceShiftTypesForDepartment>>,
          TError,
          Awaited<ReturnType<typeof getRequestableAbsenceShiftTypesForDepartment>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetRequestableAbsenceShiftTypesForDepartment<TData = Awaited<ReturnType<typeof getRequestableAbsenceShiftTypesForDepartment>>, TError = ErrorType<unknown>>(
 params?: GetRequestableAbsenceShiftTypesForDepartmentParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getRequestableAbsenceShiftTypesForDepartment>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }

export function useGetRequestableAbsenceShiftTypesForDepartment<TData = Awaited<ReturnType<typeof getRequestableAbsenceShiftTypesForDepartment>>, TError = ErrorType<unknown>>(
 params?: GetRequestableAbsenceShiftTypesForDepartmentParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getRequestableAbsenceShiftTypesForDepartment>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getGetRequestableAbsenceShiftTypesForDepartmentQueryOptions(params,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}






export const getGetRequestableAbsenceShiftTypesForDepartmentSuspenseQueryOptions = <TData = Awaited<ReturnType<typeof getRequestableAbsenceShiftTypesForDepartment>>, TError = ErrorType<unknown>>(params?: GetRequestableAbsenceShiftTypesForDepartmentParams, options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof getRequestableAbsenceShiftTypesForDepartment>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetRequestableAbsenceShiftTypesForDepartmentQueryKey(params);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof getRequestableAbsenceShiftTypesForDepartment>>> = ({ signal }) => getRequestableAbsenceShiftTypesForDepartment(params, { signal, ...requestOptions });





   return  queryOptionsBuilder({ queryKey, ...queryOptions, queryFn: queryOptions?.queryFn ?? queryFn}) as UseSuspenseQueryOptions<Awaited<ReturnType<typeof getRequestableAbsenceShiftTypesForDepartment>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> } & { throwOnError?: ((this: never, error: TError) => boolean) & { readonly __inferenceOnly: never } }
}

export type GetRequestableAbsenceShiftTypesForDepartmentSuspenseQueryResult = NonNullable<Awaited<ReturnType<typeof getRequestableAbsenceShiftTypesForDepartment>>>
export type GetRequestableAbsenceShiftTypesForDepartmentSuspenseQueryError = ErrorType<unknown>


export function useGetRequestableAbsenceShiftTypesForDepartmentSuspense<TData = Awaited<ReturnType<typeof getRequestableAbsenceShiftTypesForDepartment>>, TError = ErrorType<unknown>>(
 params: undefined |  GetRequestableAbsenceShiftTypesForDepartmentParams, options: { query:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof getRequestableAbsenceShiftTypesForDepartment>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetRequestableAbsenceShiftTypesForDepartmentSuspense<TData = Awaited<ReturnType<typeof getRequestableAbsenceShiftTypesForDepartment>>, TError = ErrorType<unknown>>(
 params?: GetRequestableAbsenceShiftTypesForDepartmentParams, options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof getRequestableAbsenceShiftTypesForDepartment>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetRequestableAbsenceShiftTypesForDepartmentSuspense<TData = Awaited<ReturnType<typeof getRequestableAbsenceShiftTypesForDepartment>>, TError = ErrorType<unknown>>(
 params?: GetRequestableAbsenceShiftTypesForDepartmentParams, options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof getRequestableAbsenceShiftTypesForDepartment>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }

export function useGetRequestableAbsenceShiftTypesForDepartmentSuspense<TData = Awaited<ReturnType<typeof getRequestableAbsenceShiftTypesForDepartment>>, TError = ErrorType<unknown>>(
 params?: GetRequestableAbsenceShiftTypesForDepartmentParams, options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof getRequestableAbsenceShiftTypesForDepartment>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
 ):  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getGetRequestableAbsenceShiftTypesForDepartmentSuspenseQueryOptions(params,options)

  const query = useSuspenseQuery(queryOptions, queryClient) as  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}






